import React from "react";
import Moment from "react-moment";

const ActivityTimestamp = props => (
  <Moment format="M/D/YYYY [at] hh:mm a" {...props} />
);

export default ActivityTimestamp;



// WEBPACK FOOTER //
// ./src/components/activities/ActivityTimestamp.js